"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineMathState = void 0;
const ui_1 = require("@jsonjoy.com/ui");
const slate_1 = require("slate");
const math_1 = require("../behavior/math");
/**
 * State for the inline-math editing popup.
 */
class InlineMathState {
    constructor(mutxt) {
        this.mutxt = mutxt;
        this.open = ui_1.rsync.val(false);
        this.point = ui_1.rsync.val(undefined);
        /** When non-null, we are editing an existing inline math node. */
        this.editingPath = ui_1.rsync.val(null);
        this.editingThingId = ui_1.rsync.val(null);
        this.draftVal = ui_1.rsync.val('');
        this.draftSize = ui_1.rsync.val('M');
        this.draftLabel = ui_1.rsync.val('');
        /** Snapshot of the editor selection at open time. */
        this.rangeSnapshot = ui_1.rsync.val(null);
        this.openInsert = () => {
            if (this.mutxt.readOnly.value)
                return false;
            const point = this.capturePoint();
            if (!point)
                return false;
            this.rangeSnapshot.set(this.mutxt.editor.selection ?? null);
            this.editingPath.set(null);
            this.editingThingId.set(null);
            this.draftVal.set('');
            this.draftSize.set('M');
            this.draftLabel.set('');
            this.point.set(point);
            this.open.set(true);
            return true;
        };
        this.openEdit = (element, path) => {
            if (this.mutxt.readOnly.value)
                return false;
            const point = this.capturePoint();
            if (!point)
                return false;
            const id = element['@thing'];
            const thing = id ? this.mutxt.things.get(id) : undefined;
            this.rangeSnapshot.set(null);
            this.editingPath.set(path);
            this.editingThingId.set(id ?? null);
            this.draftVal.set(thing?.val ?? '');
            this.draftSize.set(thing?.size === 'S' ? 'S' : 'M');
            this.draftLabel.set(thing?.label ?? '');
            this.point.set(point);
            this.open.set(true);
            return true;
        };
        this.setDraftVal = (value) => {
            this.draftVal.set(value);
            this.persistIfEditing();
        };
        this.setDraftSize = (value) => {
            this.draftSize.set(value === 'S' ? 'S' : 'M');
            this.persistIfEditing();
        };
        this.setDraftLabel = (value) => {
            this.draftLabel.set(value);
            this.persistIfEditing();
        };
        this.persistIfEditing = () => {
            const id = this.editingThingId.value;
            if (!id)
                return;
            const val = this.draftVal.value.trim();
            if (!val)
                return;
            const size = this.draftSize.value === 'S' ? 'S' : 'M';
            const label = this.draftLabel.value.trim();
            this.mutxt.things.update(id, {
                val,
                size: size === 'M' ? undefined : 'S',
                label: label || undefined,
            });
            this.mutxt.sync(false);
        };
        this.close = () => {
            if (!this.open.value)
                return;
            this.open.set(false);
            this.point.set(undefined);
            this.editingPath.set(null);
            this.editingThingId.set(null);
            this.rangeSnapshot.set(null);
            this.mutxt.api.focus();
        };
        this.apply = () => {
            const editingId = this.editingThingId.value;
            if (editingId) {
                this.close();
                return;
            }
            const val = this.draftVal.value.trim();
            if (!val)
                return;
            const size = this.draftSize.value === 'S' ? 'S' : 'M';
            const label = this.draftLabel.value.trim();
            const snapshot = this.rangeSnapshot.value;
            if (snapshot) {
                try {
                    slate_1.Transforms.select(this.mutxt.editor, snapshot);
                }
                catch { }
            }
            const id = this.mutxt.things.add({
                '@type': 'math',
                val,
                ...(size === 'M' ? {} : { size: 'S' }),
                ...(label ? { label } : {}),
            });
            (0, math_1.insertMathInline)(this.mutxt.editor, id);
            this.mutxt.sync(false);
            this.close();
        };
        this.remove = () => {
            const path = this.editingPath.value;
            if (!path)
                return;
            if (!(0, math_1.removeMathInlineAtPath)(this.mutxt.editor, path))
                return;
            this.mutxt.sync(false);
            this.close();
        };
    }
    capturePoint() {
        const shellBox = this.mutxt.shellBox.value;
        if (!shellBox)
            return undefined;
        const [x, y, width] = shellBox;
        return { x: x + width / 2, y, dx: 0, dy: 1 };
    }
}
exports.InlineMathState = InlineMathState;
